import { useApi, waLink } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-2.15a12.1 12.1 0 0 0 3.79.61h.01C22.68 27.46 28 22.1 28 15.49 28 8.88 22.68 3 16.04 3Zm0 22.4h-.01c-1.17 0-2.32-.31-3.32-.9l-.24-.14-4.9 1.28 1.31-4.76-.16-.25a9.83 9.83 0 0 1-1.52-5.26c0-5.49 4.48-9.95 9.85-9.95 5.36 0 9.84 4.6 9.84 10.09 0 5.48-4.48 9.89-9.85 9.89Zm5.4-7.4c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.46.13-.6.13-.14.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.57-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47 0 1.45 1.06 2.86 1.21 3.06.15.2 2.09 3.18 5.06 4.46.71.3 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.75-.71 2-1.4.25-.69.25-1.28.17-1.4-.07-.13-.27-.2-.57-.35Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const { data: s } = useApi("/settings");
  const { t } = useLang();
  if (!s?.contact_whatsapp) return null;
  return (
    <a href={waLink(s.contact_whatsapp, t("wa.msg"))} target="_blank" rel="noreferrer" aria-label={t("wa.label")} data-testid="whatsapp-float"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] p-3.5 text-white shadow-[0_10px_30px_-8px_rgba(0,0,0,0.45)] transition-transform duration-200 hover:scale-105 sm:bottom-7 sm:right-7">
      <WaIcon />
      <span className="hidden pr-1 text-sm font-extrabold sm:inline">{t("wa.label")}</span>
    </a>
  );
};
